import { OnInit, Component, Input } from '@angular/core';
import { QuestionBase } from '../../../form/models/question-base.model';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { FormService } from '../../../form/form.service';
import { QuestionControlService } from '../../../form/question-control.service';
import { FormGroup } from '@angular/forms';
import { ChartService } from '../../services/chart.service';


@Component({
    selector: 'app-chart-group',
    templateUrl: './chart-group.component.html',
    styleUrls: ['./chart-group.component.scss'],
    providers: [QuestionControlService, FormService] // to provide single instance of each formservice to chart group
    ,
    standalone: false
})
export class ChartGroupComponent implements OnInit {

    constructor(
        private baseService:BaseService,
        private chartService:ChartService,
        public formService:FormService,
        private qcs: QuestionControlService
    ){

    }
    @Input() item: any;
    @Input() selection:any; // elementref where selected widget will be shown
    public allFields:QuestionBase<any>[];
    public filterForm:FormGroup;
    public _currentDatasource:any={};
    public _subscriptionFields:any;
    public _chartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    public _chartConfig:any = {
        chartData : [],
        chartColors: [],
        chartLabels: []
    }

    ngOnInit() {
        var chartFilterFields = [];
        if(this.item.type_filter != undefined){
            chartFilterFields.push(this.item.type_filter);
        }

        if(this.item.time_filter != undefined){
            chartFilterFields.push(this.item.time_filter);
        }

        if(chartFilterFields.length){
            this.formService.setForm(this.filterForm);
            this._subscriptionFields = this.formService.getOpionChanged().subscribe((data)=>{
                if(data && data.question != undefined){
                    this.handleDefaultFilterBehaviour(data.question.key);
                }
            });
            this.allFields = this.formService.buildQuestions(chartFilterFields,{visible:true},{});
            this.filterForm = this.qcs.toFormGroup([{questions:this.allFields}],'');            
           
        }
        // this.chartType = 'doughnut';
        // this.chartLabels = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
        //this.chartData = [{ data: [350, 450, 100], label: 'Sales' }];
        
    }

    ngAfterViewInit(){
       
    }

    handleDefaultFilterBehaviour(key){
        setTimeout(()=>{
            /**** REMOVING USING JAVASCRIPT */
            var filter = <any> document.getElementById(key);
            if(filter){
            filter.options[0] = null;
            this.filterForm.controls[key].setValue(this.formService.questionMapping[key].options[0]);
            this.onFilterValueChanged({question:this.formService.questionMapping[key]});
            }
        });
    }

    
    onFilterValueChanged(event){
        if(event.question != undefined){
            if(this.filterForm.controls != undefined && this.filterForm.controls[event.question.key] != undefined){
                this._currentDatasource = this.getDataSource(this._currentDatasource,event.question.key);
            }
        }

        //check if application,resource and filter exists then fire get api request
        console.log(this._currentDatasource);
        if(this._currentDatasource.application != undefined && this._currentDatasource.application && this._currentDatasource.resource != undefined && this._currentDatasource.resource){
            if(this._currentDatasource.query_id == undefined || !this._currentDatasource.query_id){
                this._currentDatasource.query_id = 'get_chart';
            }
            if(this._currentDatasource.args == undefined){
                this._currentDatasource.args = '';               
            }

            this.chartService.getChart(this._currentDatasource,this.item.labels,(response)=>{
                if(response && response.chartData != undefined){
                    this._chartConfig.chartData = response.chartData;
                    this._chartConfig.chartLabels = response.chartLabels;
                }else{
                    this._chartConfig.chartData = [];
                }
            })

        }

        
    }

    getDataSource(datasource,key){
        var obj = this.filterForm.controls[key].value;
        if(obj == undefined){
            return {};
        }
        var tempObj:any = {...datasource};
        if(obj.resource != undefined && obj.resource){
            tempObj.resource = obj.resource
        }

        if(obj.application != undefined && obj.application){
            tempObj.application = obj.application
        }

        if(obj.query_id != undefined && obj.query_id){
            tempObj.query_id = obj.query_id
        }

        //handling args
        tempObj.args = this.handlePreviousArg('args');
        //handling filter
        tempObj.filter = this.handlePreviousArg('filter');

        return tempObj;
    }

    handlePreviousArg(type){
        var args_type = '';

        var time_filter = this.filterForm.controls["time_filter"];
        if(time_filter.value && time_filter.value[type] != undefined && time_filter.value[type]){
            var str = time_filter.value[type];
            args_type += str;

            if(time_filter.value.time != undefined && type == 'args'){
                args_type = this.baseService.handleTimeRange(args_type,time_filter.value.time);
            }
        }else{
            if(time_filter.value.time != undefined && type == 'args'){
                args_type = this.baseService.handleTimeRange('',time_filter.value.time);
            }
        }
        var type_filter = this.filterForm.controls["type_filter"];
        if(type_filter.value && type_filter.value[type] != undefined && type_filter.value[type]){
            var str = type_filter.value[type];
            args_type += ((str=='')?'':',')+str;
        }

        return args_type;
    }

    ngOnDestroy(){
        if(this._subscriptionFields && this._subscriptionFields.unsubscribe != undefined){
            this._subscriptionFields.unsubscribe();
        }
    }
}